import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../util/Auth";
import { formatDateTime } from "../../util/timezone.service";

type UseOcorrenciaResult = {
  dataAtual: string;
  nomeUsuario: string;
  place: string;
  mensagem: string;
  setPlace: React.Dispatch<React.SetStateAction<string>>;
  setMensagem: React.Dispatch<React.SetStateAction<string>>;
  enviarOcorrencia: () => void;
};

function formatarDataAtual(data: Date, formatPattern: string): string {
  return formatDateTime(data, formatPattern);
}

export default function useOcorrencia(): UseOcorrenciaResult {
  const { user } = useAuth();
  const { t } = useTranslation();
  const [place, setPlace] = useState("");
  const [mensagem, setMensagem] = useState("");
  const nomeUsuario =
    `${user?.first_name ?? ""} ${user?.last_name ?? ""}`.trim() || "Usuario";

  const dataAtual = useMemo(() => {
    const formatPattern = t("pages.configuration.dateTimeFormats.long");
    return formatarDataAtual(new Date(), formatPattern);
  }, [t]);

  const enviarOcorrencia = () => {
    const placeNormalized = place.trim();
    const mensagemNormalizada = mensagem.trim();

    if (!placeNormalized || !mensagemNormalizada) {
      window.alert("Preencha local e ocorrencia antes de enviar.");
      return;
    }

    const payload = {
      data: new Date().toISOString(),
      nomeUsuario,
      place: placeNormalized,
      mensagem: mensagemNormalizada
    };

    // Mock de envio enquanto API nao esta conectada.
    console.log("Ocorrencia enviada:", payload);
    window.alert("Mensagem enviada com sucesso.");

    setPlace("");
    setMensagem("");
  };

  return {
    dataAtual,
    nomeUsuario,
    place,
    mensagem,
    setPlace,
    setMensagem,
    enviarOcorrencia
  };
}
